var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"table-column-header d-flex align-items-center"},[_vm._v(" "+_vm._s(_vm.label)+" "),(_vm.field.sortable)?_c('FontAwesomeIcon',{staticClass:"icon ml-2",attrs:{"icon":['fad', _vm.icon]}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }